import useReveal from "../hooks/useReveal";
import { services } from "../mock";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

// Show only a few key services on the home page; full list lives on /palvelut
const FEATURED_COUNT = 3;

export default function Services() {
  useReveal();
  const featured = services.slice(0, FEATURED_COUNT);

  return (
    <section id="palvelut" className="relative py-16 sm:py-20 lg:py-28 bg-white overflow-hidden">
      {/* Decorative glow orbs */}
      <div className="blob absolute -top-10 -left-16 w-72 h-72 bg-primary/10 hidden md:block" />
      <div className="blob blob-slow absolute bottom-0 -right-20 w-80 h-80 bg-sky-400/10 hidden md:block" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl reveal">
          <span className="text-sm font-semibold tracking-[0.18em] uppercase text-primary">
            Palvelut
          </span>
          <h2 className="mt-3 font-extrabold text-2xl sm:text-3xl lg:text-[42px] text-slate-900 leading-tight">
            Keskeiset sähköpalvelumme
          </h2>
          <p className="mt-3 text-slate-600 text-base sm:text-lg">
            Muutama nostettu palvelu – katso koko valikoima omalta sivultaan.
          </p>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((s, i) => {
            const Icon = s.icon;
            const inner = (
              <>
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center w-14 h-14 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                    <Icon className="w-7 h-7" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-wider text-primary/70 bg-primary/5 rounded-full px-3 py-1">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-bold text-lg text-slate-900 leading-snug">
                  {s.title}
                </h3>
                <p className="mt-1.5 text-sm font-medium text-primary">{s.short}</p>
                {s.href && (
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary">
                    Katso asiakkaat
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </span>
                )}
              </>
            );
            const linkCls =
              "service-card shine reveal group relative rounded-2xl border border-border bg-white p-6 block hover:border-primary/40 hover:shadow-[0_20px_50px_-20px_rgba(20,80,180,0.35)]";
            const staticCls =
              "reveal relative rounded-2xl border border-border bg-white p-6 block";
            return s.href ? (
              <Link
                key={s.id}
                to={s.href}
                className={linkCls}
                style={{ animationDelay: `${i * 60}ms` }}
              >
                {inner}
              </Link>
            ) : (
              <div
                key={s.id}
                className={staticCls}
                style={{ animationDelay: `${i * 60}ms` }}
              >
                {inner}
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex justify-center">
          <Button
            asChild
            size="lg"
            className="rounded-full px-7 h-12 text-base gap-2 shadow-lg shadow-primary/20"
          >
            <Link to="/palvelut">
              Katso kaikki palvelut
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
